{
    "Title": "Gérer les files d'attente",
    "ManageQueuesDescriptionTitle": "Description",
    "ManageQueuesCQConfigurationsTitle": "Configurations CQ",
    "ManageQueuesResourceAccountsTitle": "Comptes de ressources",
    "ManageQueuesMonitoringStatusTitle": "État de surveillance",
    "ManageQueueFiltersTitle": "Filtres",
    "ManageQueueCallMonitoringHistoric": "Historique",
    "ManageQueueCallMonitoringRealTime": "en temps réel",
    "ManageQueueCallMonitoringRealTimeForced": "Temps réel (forcé)",
    "ManageQueueCallMonitoringUnknown": "Inconnu",
    "ManageQueueCallCQConfigurationCompatible": "Compatible",
    "ManageQueueCallCQConfigurationIncompatible": "Incompatible",
    "ManageQueuesQueueFilterAll": "Toutes les files d'attente",
    "ManageQueuesFilterCompatible": "Files d'attente compatibles",
    "ManageQueuesFilterIncompatible": "Files d'attente incompatibles",
    "ManageQueue_DisableEnableRealtime_Confirm": "Confirmer",
    "ManageQueue_DisableEnableRealtime_Cancel": "Annuler",
    "ManageQueue_MonitorAllMessage": "Êtes-vous sûr de vouloir activer la surveillance en temps réel pour toutes les files d’attente ?",
    "ManageQueue_UnmonitorAllMessage": "Êtes-vous sûr de vouloir désactiver la surveillance en temps réel pour toutes les files d’attente ?",
    "ManageQueue_Loading_Monitoring_All": "Activation de la surveillance en temps réel pour toutes les files d'attente",
    "ManageQueue_Loading_Unmonitoring_All": "Désactiver la surveillance en temps réel pour toutes les files d'attente",
    "ManageQueue_Pending_Queue_Disabling": "Désactivation de la surveillance...",
    "ManageQueue_Pending_Queue_Enabling": "Activation de la surveillance...",
    "ManageQueue_Disable_RT_Popper": "Désactiver la surveillance en temps réel sur toutes les files d'attente",
    "ManageQueue_Enable_RT_Popper": "Activer la surveillance en temps réel sur toutes les files d'attente",
    "ManageQueues_Not_Found_Error": "Aucune file d'attente correspondant à cette recherche n'a été trouvée",
    "NAME": "ManageQueues"
}